module.exports = __webpack_public_path__ + "static/media/picture-(10).6cf40947.JPG";